import Vue from 'vue'
import { URL_FILES, URL_LOTS } from '@/constants/urls.js'
import { MYME_TYPES } from '@/constants/settings.js'
import { BUSINESS_FILES, ERRORS, AXIOS_REQUESTS, GENERAL_FILES } from '@/constants/store.js'

const state = {
  [BUSINESS_FILES.STATE.REQUEST_FILES]: [],
  [BUSINESS_FILES.STATE.REQUIRED_DOCUMENT_TYPES]: [],
  [BUSINESS_FILES.STATE.CURRENT_FILE]: null
}

const actions = {
  async [BUSINESS_FILES.ACTIONS.DOWNLOAD_BUSINESS_FILE] ({ commit, dispatch }, model) {
    const url = `${Vue.getBusinessHost()}${URL_FILES}/${model.fileId}?${Vue.helpers.getQueryParamsString()}`

    await dispatch(GENERAL_FILES.ACTIONS.DOWNLOAD_FILE_WITH_SETTINGS, url, { root: true })
  },
  async [BUSINESS_FILES.ACTIONS.UPLOAD_BUSINESS_FILE] ({ commit, dispatch }, model) {
    const documentType = model.documentType
    model = {
      url: `${Vue.getBusinessHost()}${URL_FILES}/signable`,
      model: model.form,
      settings: { headers: { 'Content-Type': MYME_TYPES.FORM_DATA } }
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(BUSINESS_FILES.MUTATIONS.ADD_BUSINESS_FILE_TO_STORE_LIST, { ...resp.data, documentType })
    return resp.data
  },
  async [BUSINESS_FILES.ACTIONS.UPLOAD_SINGLE_BUSINESS_FILE] ({ commit, dispatch }, model) {
    const documentType = model.documentType
    model = {
      url: `${Vue.getBusinessHost()}${URL_FILES}/signable`,
      model: model.form,
      settings: { headers: { 'Content-Type': MYME_TYPES.FORM_DATA } }
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(BUSINESS_FILES.MUTATIONS.UPLOAD_SINGLE_BUSINESS_FILE, { ...resp.data, documentType })
  },
  async [BUSINESS_FILES.ACTIONS.SAVE_FILE_SIGNATURE] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_FILES}/${model.fileId}/signatures`,
      model: model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [BUSINESS_FILES.ACTIONS.ATTACH_FILE_TO_LOT_REQUEST] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/requests/${model.requestType}/attachments`,
      model: { fileId: model.fileId }
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [BUSINESS_FILES.ACTIONS.DELETE_BUSINESS_FILE] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_FILES}/${model.fileId}`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.DELETE_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [BUSINESS_FILES.ACTIONS.GET_LOT_REQUEST_FILES] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/requests/${model.requestType}/attachments?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(BUSINESS_FILES.MUTATIONS.GET_LOT_REQUEST_FILES, resp.data || [])
  },
  async [BUSINESS_FILES.ACTIONS.GET_LOT_REQUEST_REQUIRED_DOCUMENT_TYPES] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/requests/${model.requestType}/documentTypes?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(BUSINESS_FILES.MUTATIONS.GET_LOT_REQUEST_REQUIRED_DOCUMENT_TYPES, resp.data || [])
  },
  async [BUSINESS_FILES.ACTIONS.REMOVE_FILE_FROM_ATTACHMENT] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/requests/${model.requestType}/attachments/${model.fileId}`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.DELETE_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [BUSINESS_FILES.ACTIONS.CLEAR_LOT_REQUEST_REQUIRED_DOCUMENT_TYPES] ({ commit }) {
    commit(BUSINESS_FILES.MUTATIONS.CLEAR_LOT_REQUEST_REQUIRED_DOCUMENT_TYPES)
  },
  async [BUSINESS_FILES.ACTIONS.CLEAR_LOT_REQUEST_FILES] ({ commit }) {
    commit(BUSINESS_FILES.MUTATIONS.CLEAR_LOT_REQUEST_FILES)
  },
  async [BUSINESS_FILES.ACTIONS.CLEAR_SINGLE_BUSINESS_FILE] ({ commit }) {
    commit(BUSINESS_FILES.MUTATIONS.CLEAR_SINGLE_BUSINESS_FILE)
  }
}
const mutations = {
  [BUSINESS_FILES.MUTATIONS.ADD_BUSINESS_FILE_TO_STORE_LIST] (state, requestFiles) {
    if (!state[BUSINESS_FILES.STATE.REQUEST_FILES]) { state[BUSINESS_FILES.STATE.REQUEST_FILES] = [] }
    if (state[BUSINESS_FILES.STATE.REQUEST_FILES].length === 0) {
      state[BUSINESS_FILES.STATE.REQUEST_FILES].push(requestFiles)
    } else {
      const fileInfo = state[BUSINESS_FILES.STATE.REQUEST_FILES].find(el => el.documentType === requestFiles.documentType)
      const newInfo = {
        ...fileInfo,
        ...requestFiles,
        signature: null
      }
      const filtered = state[BUSINESS_FILES.STATE.REQUEST_FILES].filter(el => el.documentType !== requestFiles.documentType)
      filtered.push(newInfo)
      state[BUSINESS_FILES.STATE.REQUEST_FILES] = filtered
    }
  },
  [BUSINESS_FILES.MUTATIONS.GET_LOT_REQUEST_REQUIRED_DOCUMENT_TYPES] (state, requestDocumentTypes) {
    state[BUSINESS_FILES.STATE.REQUIRED_DOCUMENT_TYPES] = requestDocumentTypes
  },
  [BUSINESS_FILES.MUTATIONS.UPLOAD_SINGLE_BUSINESS_FILE] (state, file) {
    state[BUSINESS_FILES.STATE.CURRENT_FILE] = file
  },
  [BUSINESS_FILES.MUTATIONS.GET_LOT_REQUEST_FILES] (state, requestFiles) {
    state[BUSINESS_FILES.STATE.REQUEST_FILES] = requestFiles
  },
  [BUSINESS_FILES.MUTATIONS.CLEAR_LOT_REQUEST_REQUIRED_DOCUMENT_TYPES] (state) {
    state[BUSINESS_FILES.STATE.REQUIRED_DOCUMENT_TYPES] = []
  },
  [BUSINESS_FILES.MUTATIONS.CLEAR_LOT_REQUEST_FILES] (state) {
    state[BUSINESS_FILES.STATE.REQUEST_FILES] = []
  },
  [BUSINESS_FILES.MUTATIONS.CLEAR_SINGLE_BUSINESS_FILE] (state) {
    state[BUSINESS_FILES.STATE.CURRENT_FILE] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
